import React from 'react';
import {
  LayoutDashboard, Users, FileText, Send, Radio, ListChecks, Megaphone,
  Luggage, CloudLightning, MapPin, Globe, Tablet, Settings, RefreshCw, History,
} from 'lucide-react';
import AppShell from './AppShell';

// 'Reports' (AdminReportsPage, /admin/reports) is a placeholder page and was
// already deliberately left out of the old Sidebar's nav list — kept that
// way here rather than surfacing an unfinished page.
const NAV_ITEMS = [
  { to: '/admin/dashboard',              icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/users',                  icon: Users,           label: 'Users' },
  { to: '/admin/templates',              icon: FileText,        label: 'Templates' },
  { to: '/admin/template-requests',      icon: Send,            label: 'Template Requests' },
  { to: '/admin/gates',                  icon: Radio,           label: 'Gates' },
  { to: '/admin/gate-sessions',          icon: ListChecks,      label: 'Gate Sessions' },
  { to: '/admin/airport-announcements',  icon: Megaphone,       label: 'Airport Announcements' },
  { to: '/admin/belt-assignments',       icon: Luggage,         label: 'Belt Assignments' },
  { to: '/admin/weather-alerts',         icon: CloudLightning,  label: 'Weather Alerts' },
  { to: '/admin/zones',                  icon: MapPin,          label: 'Zones' },
  { to: '/admin/destination-languages',  icon: Globe,           label: 'Destination Languages' },
  { to: '/admin/devices',                icon: Tablet,          label: 'Display Devices' },
  { to: '/admin/rules',                  icon: Settings,        label: 'Announcement Rules' },
  { to: '/admin/flight-sync',            icon: RefreshCw,       label: 'Flight Sync' },
  { to: '/admin/audit-log',              icon: History,         label: 'Audit Log' },
];

export default function AdminLayout() {
  return (
    <AppShell
      roleLabel="Administrator"
      navItems={NAV_ITEMS}
      contentClassName="px-4 sm:px-6 lg:px-8 py-6"
    />
  );
}
